import { Navigate, useLocation } from 'react-router-dom';
import { getUser, isAuth } from './auth';

function RequireRole({ allowed, children }) {
    const user = getUser();
    const location = useLocation();
    const auth = isAuth()

    if (!user && !auth) {
        return <Navigate to="/auth/login" replace state={{ from: location }} />;
    }

    // role_id bo'yicha tekshirish (allowed - role_id yoki role_id lar massivi)
    const ok = Array.isArray(allowed)
        ? allowed.includes(user.roles_id)
        : user.roles_id === allowed;

    if (!ok) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default RequireRole;